<template>
  <ui-collapse
    id="policies"
    data-test="policies-accordion"
    :selected="open"
    :collapse-id="`collapse-policies`"
    @collapse-close="$emit('subsection-closed')"
  >
    <template #ui-collapse-title>
      <translate>Policies</translate>
    </template>
    <template #ui-collapse-body>
      <translate
        tag="h3"
        class="canx-policy"
        :tt="{ campsiteName: campsite.name }"
      >
        {campsiteName} cancellation policy
      </translate>
      <div
        ref="campsiteCancellationPolicy"
        class="policies-section"
        v-html="campsite.policies"
      />
      <lazy-google-translate-button
        v-if="campsite.cancellationPolicyNeedsTranslation"
        :parent="campsiteCancellationPolicyRef"
      />

      <permitted-arrival-departure-times-section
        :arrival-time="campsite.arrivalTime"
      >
        <permitted-arrival-departure-times
          v-if="campsite.useCampingArrivalDepartTimes"
          :arrival-from="campsite.campingArrivalTimeFrom"
          :arrival-to="campsite.campingArrivalTimeTo"
          :depart-from="campsite.campingDepartTimeFrom"
        >
          <translate>Camping and touring</translate>
        </permitted-arrival-departure-times>

        <permitted-arrival-departure-times
          v-if="campsite.useOnsiteArrivalDepartTimes"
          :arrival-from="campsite.onsiteArrivalTimeFrom"
          :arrival-to="campsite.onsiteArrivalTimeTo"
          :depart-from="campsite.onsiteDepartTimeFrom"
        >
          <translate>On-site accommodation</translate>
        </permitted-arrival-departure-times>
      </permitted-arrival-departure-times-section>

      <translate tag="p">
        Please note that your deposit is paid to Pitchup.com and is
        non-refundable.
      </translate>

      <campsite-tax-terms
        v-if="displayTax"
        :city-tax="campsite.cityTax"
        :exclusive-taxes="campsite.exclusiveTaxes"
        :arrival-taxes="campsite.arrivalTaxes"
        class="policies-section"
      />

      <campsite-payment-methods
        :methods="campsite.cardTypes"
        class="policies-section"
      />
    </template>
  </ui-collapse>
</template>

<script lang="ts">
import VueHooksInfoMixin from '~/mixins/VueHooksInfoMixin'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { CampsiteDetails } from '../../../campsite-details/types'

@Component({
  mixins: [VueHooksInfoMixin],
})
class CampsitePolicies extends Vue {
  @Prop({ required: true })
  campsite: CampsiteDetails

  @Prop({ default: false })
  open: boolean

  get displayTax() {
    return (
      this.campsite.cityTax.length ||
      this.campsite.exclusiveTaxes.length ||
      (this.campsite.arrivalTaxes && this.campsite.arrivalTaxes.length)
    )
  }

  get campsiteCancellationPolicyRef() {
    // refs are not reactive, so need this little trick to make sure it's there when needed
    if (!this.isMounted) {
      return undefined
    }
    return this.$refs.campsiteCancellationPolicy as Element
  }
}

export default toNative(CampsitePolicies)
</script>
<style scoped>
.policies-section {
  margin-top: 1em;
}

.policies-section :deep(p) {
  margin: 0 0 1em;
}

.policies-section :deep(.cardtype-title) {
  margin: 2em 0 0.5em;
  font-size: 1.25em;
  font-weight: bold;
  display: block;
}

#policies :deep(h3) {
  margin-top: 2em;
}

#policies h3.canx-policy {
  margin-top: 0;
}
</style>
